var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVehicleDispatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#3282FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19995 4.3999C4.09538 4.3999 3.19995 5.29533 3.19995 6.3999V10.6399H4.06805C4.02382 10.7619 3.99976 10.8932 3.99976 11.0299C3.99976 11.6761 4.53701 12.1999 5.19976 12.1999C5.8625 12.1999 6.39976 11.6761 6.39976 11.0299C6.39976 10.8932 6.37569 10.7619 6.33146 10.6399H9.66844C9.62421 10.7619 9.60015 10.8932 9.60015 11.0299C9.60015 11.6761 10.1374 12.1999 10.8001 12.1999C11.4629 12.1999 12.0001 11.6761 12.0001 11.0299C12.0001 10.8931 11.9761 10.7619 11.9318 10.6399H12.8001V9.07987H10.4V9.07983H12.8001V7.51983C12.8001 6.65827 12.0838 5.95984 11.2001 5.95984H10.3514C10.1509 5.06698 9.35333 4.3999 8.39995 4.3999H5.19995ZM12 8.29987H10.4V6.73987H11.2C11.6418 6.73987 12 7.08909 12 7.51987V8.29987ZM5.1983 10.6399H5.2014C5.4216 10.6407 5.59985 10.815 5.59985 11.0299C5.59985 11.2453 5.42077 11.4199 5.19985 11.4199C4.97894 11.4199 4.79985 11.2453 4.79985 11.0299C4.79985 10.815 4.9781 10.6407 5.1983 10.6399ZM10.4 11.0299C10.4 10.8145 10.579 10.6399 10.8 10.6399C11.0209 10.6399 11.2 10.8145 11.2 11.0299C11.2 11.2453 11.0209 11.4199 10.8 11.4199C10.579 11.4199 10.4 11.2453 10.4 11.0299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleDispatch);
export default __webpack_public_path__ + "static/media/icon-vehicle-dispatch.5b7b428a16a32d7ea4359b737ce167e3.svg";
export { ForwardRef as ReactComponent };